














import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class ArrowBanner extends Vue {
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
